angular.module('SpidApp')

.factory('OrderItem',
[function () {
	var OrderItem = function (type, params) {
		params = params || {}

		this.type 			= type
		this.id     		= params.id
		this.label  		= params.label
		this.quantity		= +params.quantity
		this.quantity_send	= +params.quantity_send
		this.quantity_get   = +params.quantity_get
		this.orderId    	= params.orderId
	}

	
	OrderItem.PRODUCT = 'Product'
	OrderItem.OPERATIONAL_PRODUCT = 'OperationalProduct'	

	OrderItem.prototype._opQuantity = function (diff) {
		this.quantity = +this.quantity + diff
	}
	OrderItem.prototype._opQuantityGet = function (diff) {
		this.quantity_get = +this.quantity_get + diff
	}

	OrderItem.prototype.incrementQuantity = function () {
		this._opQuantity(+1)
	}

	OrderItem.prototype.decrementQuantity = function () {
		this._opQuantity(-1)
	}
	
	OrderItem.prototype.incrementQuantityGet = function () {
		this._opQuantityGet(+1)
	}

	OrderItem.prototype.decrementQuantityGet = function () {
		this._opQuantityGet(-1)
	}

	OrderItem.prototype.isProduct = function () {
		return this.type === OrderItem.PRODUCT
	}

	OrderItem.prototype.isOperationalProduct = function () {
		return this.type === OrderItem.OPERATIONAL_PRODUCT
	}

	return OrderItem
}])

.factory('OrderItemDbAdapter',
[        'OrderItem',
function (OrderItem) {
	var OrderItemDbAdapter = {
		fromModelToDb: function (orderItem) {
			if (!orderItem) {
				throw 'OrderItemDbAdapter::fromModelToDb() - Missing parameters'
			}

			return {
				  obj_id            : orderItem.obj_id
				, unit              : orderItem.quantity
				, quantity_send     : orderItem.quantity_send
				, quantity_get      : orderItem.quantity_get
				, label             : orderItem.label
				, order_id    		: orderItem.orderId
				, obj_table_ref     : orderItem.type
			}
		},

		fromDbToModel: function (dbObject) {
			if (!dbObject) {
				throw 'OrderItemDbAdapter::fromDbToModel() - Missing parameters'
			}
			
			var orderItem = new OrderItem(dbObject.obj_table_ref, {
				  id                : dbObject.id
				, obj_id            : dbObject.obj_id
				, label             : dbObject.label
				, quantity          : dbObject.unit
				, quantity_send	    : dbObject.quantity_send
				, quantity_get      : dbObject.quantity_get
				, orderId     		: dbObject.order_id
			})
			
			return orderItem
		}
	}

	return OrderItemDbAdapter
}])